import { render } from "./DynaList.vue?vue&type=template&id=577d5d1d&scoped=true"
import script from "./DynaList.vue?vue&type=script&lang=js"
export * from "./DynaList.vue?vue&type=script&lang=js"

import "./DynaList.vue?vue&type=style&index=0&id=577d5d1d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-577d5d1d"]])

export default __exports__